/**
 * Business fee configuration and calculation utilities
 */

/**
 * Go Sit Back platform fee percentage (0%)
 * NOTE: This should eventually be moved to a configurable business settings table
 */
export const GOSITBACK_FEE_PERCENTAGE = 0;

/**
 * Calculate the platform fee amount
 * @param totalAmount - The total quote/invoice amount
 * @returns The calculated fee amount
 */
export function calculatePlatformFee(totalAmount: number): number {
  return totalAmount * GOSITBACK_FEE_PERCENTAGE;
}

/**
 * Calculate the contractor net payout
 * @param totalAmount - The total quote/invoice amount
 * @returns The net amount to be paid to the contractor
 */
export function calculateContractorPayout(totalAmount: number): number {
  return totalAmount - calculatePlatformFee(totalAmount);
}

/**
 * Get the platform fee percentage as a formatted string
 * @returns Formatted percentage string (e.g., "30%")
 */
export function getPlatformFeePercentage(): string {
  return `${(GOSITBACK_FEE_PERCENTAGE * 100).toFixed(0)}%`;
}

export const BusinessFeeUtils = {
  calculatePlatformFee,
  calculateContractorPayout,
  getPlatformFeePercentage,
  GOSITBACK_FEE_PERCENTAGE,
};
